import config from 'config'

// see @see {@link https://developers.google.com/pay/api/web/reference/object for details
export default {
  environment: config.ipay.gpay.environment,
  buttonColor: 'default',
  baseRequest: {
    apiVersion: 2,
    apiVersionMinor: 0
  },
  allowedCardNetworks: [
    'MASTERCARD',
    'VISA'
  ],
  allowedCardAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
  merchantInfo: config.ipay.gpay.merchantInfo,
  tokenizationSpecification: config.ipay.gpay.tokenizationSpecification,
  baseCardPaymentMethod: {
    type: 'CARD',
    parameters: {
      allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
      allowedCardNetworks: [
        'MASTERCARD',
        'VISA'
      ]
    }
  },
  cardPaymentMethod: null,
  paymentDataRequest: {
    baseRequest: {
      apiVersion: 2,
      apiVersionMinor: 0
    },
    allowedPaymentMethods: null,
    merchantInfo: config.ipay.gpay.merchantInfo
  }
}
